import { NewsEntity } from '@/entities';

const { newsSegments } = NewsEntity;

/**
 * 🔴 N-3 (designer 읽기 폭 스펙 §2-5, 팀장 정정 2026-09-03) — `newsWithSegment`(`/news/:id`)는
 * 죽은 파라미터 라우트다. `News.tsx`에 `useParams` 0건이라 파라미터가 무시되고 목록이 그대로
 * 렌더된다(상세 화면이 아니다).
 *
 * 원래 스펙은 이 라우트를 **제거**하라고 했으나, 팀장이 제거 대신 문서화로 바꿨다. 이유:
 * ①앱 안 어디서도 이 URL로 링크·navigate하지 않고 ②`scripts/lib/static-routes.mjs`(프리렌더
 * 대상)에도 없고 ③운영 sitemap.xml + 모든 서브 사이트맵(reports·ideas·feeds·coins·
 * real-estate·community) 전수 검색에서 `/news/`가 0건(2026-09-03 팀장 실측) — 우리가 이
 * URL을 퍼뜨린 적은 없다. **다만 Google Search Console(외부 백링크 확인 도구)은 팀장·팀원
 * 둘 다 접근 권한이 없어 "외부에서 아무도 이 URL로 들어온 적이 없다"는 미확인이다.**
 *
 * 🔴 지금 `/news/아무값`은 파라미터가 무시돼 뉴스 목록이 그대로 뜬다. 라우트를 지우면 그
 * URL은 catch-all(`*`)로 떨어져 목록 대신 404를 본다 — 외부 유입이 하나라도 있었다면 제거는
 * 개선이 아니라 악화다. 그래서 "확인해보고 안전해서 남긴 것"이 아니라 **"미확인이라 위험
 * 없는 쪽(현행 유지)을 택한 것"**이다 — 다음 사람이 이 라우트를 지우려면 위 GSC 확인부터
 * 하고 지울 것.
 *
 * 🔴 **2026-09-03 갱신 — 문서화에서 리다이렉트로 대체됨(designer 제안, 팀장 승인).** 위
 * "제거하지 않는 이유"는 여전히 유효하다(제거=404 리스크는 그대로) — 다만 문서화만으로는
 * 못 고치는 문제가 하나 더 있었다: 지금 `/news`와 `/news/:id`가 **완전히 같은 화면을
 * 서빙**해 크롤러 관점에서 중복 콘텐츠다. 주석은 중복을 없애지 못하지만 리다이렉트는
 * 없앤다 — 그리고 리다이렉트해도 사용자가 보는 화면은 오늘과 동일(목록)이라 위 404 리스크가
 * 발생하지 않는다. **GSC 백링크는 여전히 아무도 확인 못 했다 — 리다이렉트를 고르는 이유는
 * 그 확인이 없어도 안전해서지, 확인됐기 때문이 아니다.** 선례: `polymarket/routes.ts`의
 * `/polymarket/me` → `/polymarket/my`와 같은 모양(신규 패턴 아님).
 */
export const newsRoutePaths = {
  news: {
    path: 'news',
    fullPath: '/news',
  },
  newsWithSegment: {
    path: `news/${newsSegments.newsId}`,
    fullPath: `news/${newsSegments.newsId}`,
  },
};
